import { API_BASE_URL } from "@/api/api.config";
import useRestQuery from "@/remoteState/useRestQuery";

const useLegacyArticleHeaderGet = (articleSlug, params = null) => {
  const skip = articleSlug === "undefined" || !articleSlug;
  const queryString = new URLSearchParams(params).toString();
  let requestUrl = `${API_BASE_URL}/api/v2/articleheader/${articleSlug}/`;
  if (queryString) requestUrl += `?${queryString}`;
  return useRestQuery(requestUrl, { skip });
};

export default useLegacyArticleHeaderGet;
